import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {


  constructor(public snackBar: MatSnackBar, public router: Router ) { }


  logout() {
    localStorage.removeItem('token');
    this.snackBar.open('Sesión cerrada, volviendo a página de login.', null, {
            duration: 3000
          });

    this.router.navigate(['/']);
  }

}
